import { render } from "./AdminGrid.vue?vue&type=template&id=47e8e2c8"
import script from "./AdminGrid.vue?vue&type=script&lang=js"
export * from "./AdminGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__